import CommonLayout from 'components/FilmPage/FilmDescription/CommonLayout';
import styled from 'styled-components';
import { mediaDesktop } from 'utils/responsive';

export default styled(CommonLayout)`
  ${mediaDesktop(`
    height: 290vh;
  `)}
`;
